const HOME_SCROLL_KEY = "bespoke-home-scroll";
const RETURN_PATH_KEY = "bespoke-return-path";

export const saveHomeScrollPosition = () => {
  if (typeof window === "undefined") return;
  try {
    const position = [window.scrollX || 0, window.scrollY || 0];
    sessionStorage.setItem(HOME_SCROLL_KEY, JSON.stringify(position));
  } catch (e) {
    // ignore storage errors
  }
};

export const getHomeScrollPosition = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(HOME_SCROLL_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const clearHomeScrollPosition = () => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(HOME_SCROLL_KEY);
  } catch (e) {
    // ignore storage errors
  }
};

export const saveReturnPath = (path) => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(RETURN_PATH_KEY, path);
  } catch (e) {
    // ignore storage errors
  }
};

export const saveReturnPathFromWindow = () => {
  if (typeof window === "undefined") return;
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  saveReturnPath(path);
};

export const getReturnPath = () => {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(RETURN_PATH_KEY);
  } catch (e) {
    return null;
  }
};

export const clearReturnPath = () => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(RETURN_PATH_KEY);
  } catch (e) {
    // ignore storage errors
  }
};


